var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loginBG", style: _vm.setLoginImg }, [
    _vm.onload
      ? _c(
          "div",
          { ref: "container", staticClass: "container_lining" },
          [
            _c("span", { staticClass: "titleTOP" }, [_vm._v("用户登录")]),
            _vm._v(" "),
            _c("div", { staticClass: "divAccount" }, [
              _c("img", {
                staticClass: "icon",
                attrs: { src: _vm.path + "/common/account.png" },
              }),
              _vm._v(" "),
              _c("input", {
                ref: "username",
                staticClass: "username",
                attrs: { type: "text", value: "", placeholder: "请输入用户名" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divMima" }, [
              _c("img", {
                staticClass: "icon",
                attrs: { src: _vm.path + "/common/password.png" },
              }),
              _vm._v(" "),
              _c("input", {
                ref: "password",
                staticClass: "pwd",
                attrs: {
                  type: "password",
                  value: "",
                  placeholder: "请输入密码",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { ref: "dragDiv", staticClass: "drag" }, [
              _c("div", { staticClass: "drag_bg" }),
              _vm._v(" "),
              _c("div", { staticClass: "drag_text" }, [
                _vm._v(_vm._s(_vm.confirmWords)),
              ]),
              _vm._v(" "),
              _c("div", {
                ref: "moveDiv",
                staticClass: "handler handler_bg",
                class: { handler_ok_bg: _vm.confirmSuccess },
                staticStyle: { position: "absolute", top: "0px", left: "0px" },
                on: {
                  mousedown: function ($event) {
                    return _vm.mousedownFn($event)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "btn",
              attrs: { id: "btn" },
              on: { click: _vm.login },
            }),
            _vm._v(" "),
            _c(
              "Spin",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.spinShow,
                    expression: "spinShow",
                  },
                ],
                attrs: { fix: "" },
              },
              [
                _c("div", { staticClass: "loader" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "circular",
                      attrs: { viewBox: "25 25 50 50" },
                    },
                    [
                      _c("circle", {
                        staticClass: "path",
                        attrs: {
                          fill: "none",
                          "stroke-width": "5",
                          "stroke-miterlimit": "10",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }